import { buttonClickHandler } from "./button-click-handler";
import TextMessage from "../text-message/text-message";
import QuickReplies from "../quick-replies";

export default function Buttons(props) {
  const { message = {}, onInvokeAction, chatBotSetting, disabled, senderType } = props;
  const onClick = buttonClickHandler(onInvokeAction);
  const displayText = (message?.displayText || "").trim();

  return (
    <div className="w-full min-w-0">
      {displayText && <TextMessage message={displayText} senderType={senderType} />}
      <QuickReplies
        buttons={message?.buttons}
        chatBotSetting={chatBotSetting}
        disabled={disabled}
        onSelect={option => onClick(option.payload, option)}
      />
    </div>
  );
}
